import {
  IWork,
  IWorkLayoutProps,
  HomePageItemDataType,
  useTrackRecentlyViewed,
  useWorkPageStore,
  useWorkVersionDrawer,
  WorkLayout,
} from '@diana/core';

export interface IWorkPageLayoutProps
  extends Omit<IWorkLayoutProps, 'data' | 'work' | 'activeTaskId'> {
  work?: IWork;
}

export function WorkPageLayout(props: IWorkPageLayoutProps) {
  const { work, isSmallDevice, renderingMode, onPageChange } = props;
  const data = useWorkPageStore((store) => store.data);
  const activeTaskId = useWorkPageStore((store) => store.activeTaskId);

  useTrackRecentlyViewed({ itemId: work?.id!, dataType: HomePageItemDataType.Work });

  useWorkVersionDrawer();

  return work ? (
    <WorkLayout
      work={work}
      data={data}
      isSmallDevice={isSmallDevice}
      renderingMode={renderingMode}
      activeTaskId={activeTaskId}
      onPageChange={onPageChange}
    />
  ) : null;
}
